import React, { useState, useEffect } from 'react';
import {useTranslation} from "react-i18next";

interface VerificationCodeInputProps {
  handleValidation: () => Promise<boolean>;
  isButtonDisabled: boolean;
  buttonText: string;
  smsCode: string;
  setSMSCode: (value: string) => void;
  setButtonText: (value: string) => void;
  setIsButtonDisabled: (value: boolean) => void;
}


export const VerificationCodeInput: React.FC<VerificationCodeInputProps> = ({
  handleValidation,
  isButtonDisabled,
  buttonText,
  smsCode,
  setSMSCode,
  setButtonText,
  setIsButtonDisabled,
}) => {
  const { t } = useTranslation();
  const [timeRemaining, setTimeRemaining] = useState<number | null>(null);

  // TODO: Set the timer globally, make sure the API call is sent once every 60 seconds.
  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (timeRemaining !== null && timeRemaining > 0) {
      timer = setTimeout(() => {
        setTimeRemaining((prev) => (prev !== null ? prev - 1 : null));
      }, 1000);
    } else if (timeRemaining === 0) {
      setButtonText(t('AuthResendOTP'));
      setIsButtonDisabled(false);
      setTimeRemaining(null);
    }

    return () => clearTimeout(timer);
  }, [timeRemaining, setButtonText, setIsButtonDisabled]);

  const handleValidationWithCountdown = async () => {
    const isValid = await handleValidation();

    if (isValid) {
      // console.log("Starting countdown...");
      startCountdown();
    }
  };

  const startCountdown = () => {
    setTimeRemaining(60);
    setButtonText(t('AuthSendingOTP'));
    setIsButtonDisabled(true);
  };

  return (
    <div className="mb-6">
      <label className="block text-sm font-medium mb-2 text-left" htmlFor="code">
        {t('AuthOTP')}
      </label>
      <div className="grid grid-cols-3 gap-2">
        <input
          type="text"
          id="code"
          value={smsCode}
          onChange={(e) => setSMSCode(e.target.value)}
          maxLength={4}
          inputMode='numeric'
          pattern='[0-9]*'
          placeholder={t('AuthOTPPlaceholder')}
          className="col-span-2 border border-gray-300 rounded-md px-3 py-2 bg-white text-black"
        />
        <button
          className={`px-4 py-2 font-bold rounded-md 
            ${isButtonDisabled 
              ? "bg-orange-200 text-black cursor-not-allowed" 
              : "bg-orange-500 text-white hover:bg-orange-600"}`
          }
          onClick={handleValidationWithCountdown}
          disabled={isButtonDisabled}
        >
          {buttonText}
        </button>
      </div>

      <div className="mt-2 text-sm text-gray-300 text-left">
        {timeRemaining !== null && timeRemaining > 0 ? (
          <span>{t('AuthSendingOTPNote', {timeRemaining})}</span>
        ) : <br/>}
      </div>
    </div>
  );
};